import * as yup from 'yup';
import ValidationUtil from "../Utils/ValidationUtil";

class CampaignNameValidation {

    static async validate(form, isEdit = false) {
        try {
            let objectValidade = {
                title: yup
                    .string()
                    .max(255, ValidationUtil.MSG_FIELD_MAX)
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                fidelity_program_uuid: yup
                    .string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                sku: yup.string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                award_name: yup.string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                image: yup
                    .string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                award_image: yup
                    .string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                start_at: yup
                    .string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                end_at: yup
                    .date()
                    .when(
                        'start_at',
                        (startDate, schema) => (startDate && schema.min(
                            startDate,
                            ValidationUtil.MSG_DATE_RANGE_END
                        )),
                    ).required(ValidationUtil.MSG_FIELD_REQUIRED),
            };

            if (Array.isArray(form.images) && form.image === undefined) {
                delete objectValidade.image;
            }

            if (form.withoutValidDate === true) {
                delete objectValidade.start_at;
                delete objectValidade.end_at;
            }

            if (isEdit) {
                delete objectValidade.award_image;
            }

            let validate = yup.object().shape(objectValidade);

            validate.validateSync(form, {abortEarly: false})

            return true;

        } catch (e) {
            let erros = [];
            e.inner.forEach(function (value, index) {
                erros[value.path] = value.message;
            });

            return erros;
        }
    }

}

export default CampaignNameValidation;